import styled from 'styled-components';

export default styled.div`
  
  p {
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }

  & .btn-group {
    display: flex;
    gap: 16px;
    > div {
      width: auto;
    }
  }
 
`;